import { gql } from '@apollo/client';

export interface PodCaptureCameraItemClient {
    key: string | null;
    cameraImgUrl: string | null;
    topTips: string | null;
    firstAttributedTips: string | null;
    secondAttributedTips: string | null;
    title: string | null;
    skippable: boolean;
}

export interface PodCaptureCameraGroupClient {
    name: string;
    zh: PodCaptureCameraItemClient[];
    en: PodCaptureCameraItemClient[];
    es: PodCaptureCameraItemClient[];
}

export interface GetPodCaptureConfigForClientData {
    getPodCaptureConfigForClient: PodCaptureCameraGroupClient[] | null;
}

/** 与移动端一致：库中 cameraImgUrl 为 objectKey 时，服务端解析为可请求 URL */
export const GET_POD_CAPTURE_CONFIG_FOR_CLIENT = gql`
    query GetPodCaptureConfigForClient {
        getPodCaptureConfigForClient {
            name
            zh {
                key
                cameraImgUrl
                topTips
                firstAttributedTips
                secondAttributedTips
                title
                skippable
            }
            en {
                key
                cameraImgUrl
                topTips
                firstAttributedTips
                secondAttributedTips
                title
                skippable
            }
            es {
                key
                cameraImgUrl
                topTips
                firstAttributedTips
                secondAttributedTips
                title
                skippable
            }
        }
    }
`;
